import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useT } from 'talkr';
import questions from '../../survey/questions';
import steps from '../../survey/steps';
import s from './index.module.scss';
import common from '../index.module.scss';
import iconCross from './img/cross.png';

function validateEmail(email) {
  const re = /^/;
  return re.test(email);
}

function DogName(props) {
  const { T } = useT();
  const dispatch = useDispatch();
  const { isThisCurrentStep, isCurrentStepCompleted } = props;
  const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
  const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';
  const currentStep = useSelector((state) => state.steps.currentStep);
  const placeholder = T('dog_name_placeholder');

  const savedQuestionValues = useSelector((state) => state.questions.savedAnswers.mail);
  const list = useSelector((state) => state.steps.list);

  const savedValue = savedQuestionValues && savedQuestionValues.value;

  const [value, setValue] = useState(savedValue || '');
  const [validationWarning, setValidation] = useState(false);

  function validate() {
    setValidation(validateEmail(value));
  }

  useEffect(() => {
    validate();
  }, [value, currentStep]);

  function onChangeAction(e) {
    setValue(e.target.value);

    questions.setAnswer({
      questionName: 'dog_name',
      answerName: 'value',
      answerValue: e.target.value,
    });
  }

  useEffect(() => {
    const completed = (value !== '' && validationWarning === true);

    dispatch({
      type: 'IS_STATUSBAR_TRANSPARENT',
      payload: false,
    });

    steps.setStepStatus({
      stepName: 'dog_name',
      stepStatus: completed,
    });
  }, [value, list, currentStep, validationWarning]);

  function actionOnFocus() {
    setTimeout(() => {
      document.documentElement.scrollTop = -300;
    }, 50);
  }

  function skipMailHandler() {
    dispatch({
      type: 'SKIP_MAIL_PRESSED',
      payload: true,
    });

    setTimeout(() => {
      steps.navigate.forward({
        preventAction: 500,
      });
    }, 300);

    steps.userMovedToNextStepByClick({ byNextStep: false });
  }

  return (
    <div className={`${common.step} ${s.step} ${isThisCurrentStepClass} ${isThisStepCompletedClass}`}>
      <div className={common.stepTitle}>
        {T('dog_name')}
      </div>
      <input
        className={s.value}
        id="dog_name"
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={onChangeAction}
        onFocus={actionOnFocus}
        tabIndex={!isThisCurrentStep ? -1 : ''}
      />
      <button
        className={s.skip}
        type="button"
        onClick={skipMailHandler}
      >
        <img className={s.skip_icon} src={iconCross} alt="cross" />
        <span className={s.skip_text}>Skip</span>
      </button>
    </div>
  );
}

export default DogName;
